import React from 'react';
import './PreviewTable.scss';
import { CallFieldMappingResult } from '../store/selectors/createJobSelectors';
import MappingResultPreview from './MappingResultPreview';

export default function PreviewTable(props: Props) {
	return (
		<React.Fragment>
			<div className="mb-2">Data preview</div>
			<div className="table-container table-container_full-width preview-table__table-container">
				<table className="table">
					<tbody>
						<tr>
							<th>{props.tableData.header}</th>
							<th className="text-italic">Data parsed as</th>
						</tr>
	
						{props.tableData.rows.map((r, i) => (
							<tr key={i}>
								<td>{r.rawValue}</td>
								<td>
									<MappingResultPreview mappingResult={r.mappingResult} separator="bar" />
								</td>
							</tr>
						))}
	
						{!props.tableData.rows.length && <tr><td colSpan={2} className="text-italic">No data</td></tr>}
					</tbody>
				</table>
			</div>
			
			{props.tableData.rowsAreTruncated && <div className="text-light mt-2">Preview limited to {props.tableData.rows.length.toLocaleString()} calls</div>}
		</React.Fragment>
	);
}

interface Props {
    tableData: PreviewTableData;
}

export interface PreviewTableData {
	header: string;
	rows: { rawValue: string; mappingResult: CallFieldMappingResult; }[];
	rowsAreTruncated: boolean;
}